<template>
  <details class="accordion-item">
    <summary class="accordion-item__title">{{ title }}</summary>
    <div class="accordion-item__content">
      <slot />
    </div>
  </details>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion-item {
  border-top: 1px solid #e0e0e0;
  text-align: left;

  &:last-child {
    border-bottom: 1px solid #e0e0e0;
  }

  &[open] .accordion-item__title:after {
    border-bottom: none;
    border-left-color: transparent;
    border-right: 8px solid transparent;
    border-top-color: currentColor;
  }
}

.accordion-item__title {
  cursor: pointer;
  display: block;
  font-weight: 700;
  font-family: $font-header;
  font-size: 17px;
  list-style: none;
  padding: 1.25rem 1.875rem 1.25rem 0;
  position: relative;

  &:after {
    border-bottom: 8px solid transparent;
    border-left: 8px solid currentColor;
    border-top: 8px solid transparent;
    content: '';
    display: inline-block;
    right: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    transition: all 250ms;
  }
}

.accordion-item__content {
  p {
    margin-bottom: 1.25rem;
  }
}
</style>
